import { Component, input, output, inject, LOCALE_ID, computed } from '@angular/core';
import { FormsModule } from '@angular/forms';

@Component({
  selector: 'app-sub-products-filter',
  standalone: true,
  imports: [FormsModule],
  templateUrl: './sub-products-filter.html',
    styleUrl: './sub-products-filter.scss',
})
export class SubProductsFilter {
  private locale = inject(LOCALE_ID);

  filters = input.required<any>();
  onApply = output<void>();
  onReset = output<void>();
  onSortToggle = output<void>();

  isArabic = this.locale.startsWith('ar');

  isDateInvalid = computed(() => {
    const f = this.filters();
    if (f.createdOnFrom && f.createdOnTo) {
      return new Date(f.createdOnFrom) > new Date(f.createdOnTo);
    }
    return false;
  });
}
